module.exports = __webpack_public_path__ + "static/incidences-dashboard-a5c4e3205530041181aa1b70dcea1250.png";